import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableColumn } from '../data-table/data-table.component';

@Component({
  selector: 'app-data-list',
  imports: [CommonModule],
  template: `<div class="data-list-rows" role="list">
    @for (row of data ?? []; track row) {
      <div class="data-list__item" role="listitem">
        @if (itemTemplate) { <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: row, row: row }" /> }
        @else {
          <button type="button" class="data-list__row" (click)="rowClick.emit(row)">
            @for (column of visibleColumns; track column.key) {
              <span class="data-list__field"><small>{{ column.header }}</small>
                @if (cellTemplate) { <ng-container *ngTemplateOutlet="cellTemplate; context: { column: column.key, row: row, view: 'list' }" /> }
                @else { <span>{{ value(row, column.key) }}</span> }
              </span>
            }
          </button>
        }
      </div>
    }
  </div>`,
  styles: [`:host { display: block; } .data-list-rows { display: flex; flex-direction: column; } .data-list__item { width: 100%; min-width: 0; } .data-list__item + .data-list__item { border-top: 1px solid #e0e0e0; }
    .data-list__row { display: flex; flex-wrap: wrap; gap: 12px 24px; align-items: center; width: 100%; padding: 14px 16px; border: 0; background: transparent; color: inherit; font: inherit; text-align: left; cursor: pointer; }
    .data-list__row:hover { background: #f3f8fe; } .data-list__row:focus-visible { outline: 2px solid var(--mat-sys-primary); outline-offset: -2px; }
    .data-list__field { display: grid; gap: 4px; min-width: 0; overflow-wrap: anywhere; } .data-list__field:first-child { flex: 1; min-width: 180px; } small { font-size: 12px; color: var(--mat-sys-on-surface-variant); }`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataListComponent<T> {
  @Input() data: T[] | null | undefined = [];
  @Input() columns: TableColumn[] = [];
  @Input() cellTemplate?: TemplateRef<any>;
  @Input() itemTemplate?: TemplateRef<any>;
  @Output() rowClick = new EventEmitter<T>();
  get visibleColumns(): TableColumn[] { return this.columns.filter(column => column.visible !== false); }
  value(row: T, key: string): unknown { return (row as Record<string, unknown>)[key] ?? '—'; }
}
